module.exports = __webpack_public_path__ + "static/media/ils-check.baaa111c.svg";